import styled from 'styled-components';

import { SCREEN_WIDTH_BREAKPOINTS } from 'core/constants';

export const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.palette.grey[100]};
`;

export const Container = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
`;

export const SectionContainer = styled.div`
  gap: 20px;
  padding: 20px;
  border-radius: 8px;
  background-color: white;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const Overview = styled.div`
  display: flex;
  min-height: 90%;
  margin-bottom: 20px;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.grey[100]};
`;

export const SubmissionContainer = styled.div`
  display: flex;
  position: relative;
  flex-flow: column;
  padding: 20px 16px;
  @media (min-width: ${SCREEN_WIDTH_BREAKPOINTS.SMALL_SCREEN}px) {
    padding-left: 15%;
    padding-right: 15%;
  }
  gap: 20px;
  align-self: stretch;
`;

export const OfflineSubmitSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;

export const SyncIconContainer = styled.div`
  padding: 15px;
`;

export const OfflineSubmitSuccessTitle = styled.h2`
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const OfflineSubmitSuccessText = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  word-wrap: break-word;
`;

export const SectionTitle = styled.p`
  font-size: 24px;
  line-height: 160%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 49px;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  padding-top: 20px;
`;

export const OfflineNotificationWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 16px;
  @media (min-width: ${SCREEN_WIDTH_BREAKPOINTS.SMALL_SCREEN}px) {
    padding-left: 15%;
    padding-right: 15%;
  }
`;

export const HeaderTitle = styled.h1`
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 0;
  padding: 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 49px;
  background-color: white;
  padding 20px;
  position: relative;
`;

// Subtle green dot indicator for offline submission enabled
export const OfflineIndicator = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.success.main};
`;

export const Text = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.error.main};
`;
